import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import "./index.scss";
import { CartProvider } from "./app/providers/CartProvider";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <CartProvider>
      <App />
    </CartProvider>
  </React.StrictMode>
);
